import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { useUserOnboarding } from '@features/user';

import { useUIState } from '../../../context/uiState';
import { FRONT_CHAT_CONFIG } from '../config';
import { setLauncherVisible } from '../store';

/**
 * Hook to manage launcher visibility based on routes and initialization status
 */
export const useFrontChatVisibility = (isInitialized: boolean) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { state: UIState } = useUIState();
  const { loadedInChromeExtension } = UIState;
  const { onboardingSteps } = useUserOnboarding();

  useEffect(() => {
    // Don't show launcher until initialized
    if (!isInitialized) {
      dispatch(setLauncherVisible(false));
      return;
    }

    // Hide launcher if user hasn't completed onboarding
    const onboardingCompleted = onboardingSteps['account_creation_onboarding_completed'];
    if (!onboardingCompleted) {
      dispatch(setLauncherVisible(false));
      return;
    }

    const shouldHideLauncher =
      FRONT_CHAT_CONFIG.hiddenRoutes.some(route =>
        matchPath({ path: route, end: false }, location.pathname) !== null
      ) || loadedInChromeExtension;

    dispatch(setLauncherVisible(!shouldHideLauncher));
  }, [location.pathname, loadedInChromeExtension, dispatch, isInitialized, onboardingSteps]);
};
